import React from "react";

export const SelectedPropertyContext = React.createContext({
  selectedPropertyId: "",
  setSelectedPropertyId: () => {},
  selectedProperty: undefined,
});
